module.exports = __webpack_public_path__ + "static/media/WebPacs.a64b643f.jpg";